import React from 'react';
import styles from './flyout.scss';
import FlyoutItem from './FlyoutItem';

const columns = [
  ['Bedding', 'Curtains', 'Blinds'],
  ['Bathroom Accessories', 'Home Decoration'],
  ['Cooking'],
  ['Dining'],
  ['Storage, Laundry & Cleaning'],
  ['Garden', 'DIY, Paint & Wallpaper'],
];

const Flyout = ({
  visible,
  name = '',
  child = [],
  fetchAndStoreChildCategories,
  navigationV2Active,
  scrollToTop,
  childHierarchy,
  setOpened,
}) => {
  const groupedChildren = columns.map(column =>
    column
      .map(columnName => child.find(item => item.name === columnName))
      .filter(item => !!item)
  );

  return (
    <div className={styles.flyoutContainer}>
      {groupedChildren.map((columnChildren, index) => (
        // eslint-disable-next-line react/no-array-index-key
        <ul key={`column-${index}`} className={styles.flyoutItems}>
          {columnChildren.map(colChild => (
            <FlyoutItem
              {...colChild}
              className={styles.flyoutItem}
              key={colChild.id}
              depth={1}
              id={colChild.id}
              hierarchy={childHierarchy}
              backLabel={name}
              toggleParentOpened={setOpened}
              fetchAndStoreChildCategories={fetchAndStoreChildCategories}
              parentOpen={visible}
              openClass={styles.opened}
              navigationV2Active={navigationV2Active}
              scrollToTop={scrollToTop}
            />
          ))}
        </ul>
      ))}
    </div>
  );
};
export default Flyout;
